import { Component, Input, ContentChild } from '@angular/core';

import { BoxSmallContentDirective, BoxSmallFooterDirective, BoxSmallHeaderDirective } from './box-small.directive';
export class BoxSmallComponent {
public backgroundColor: string;
public contentColor: string;
public contentStyleClass = 'small-box-content';
public footer: string;
public footerColor: string;
public footerStyleClass = 'small-box-footer';
public header: string;
public headerColor: string;
public headerStyleClass = 'small-box-header';
public iconColor: string;
public iconStyleClass = 'ion ion-bag';
public styleClass = 'small-box';
public boxSmallHeaderDirective: BoxSmallHeaderDirective;
public boxSmallFooterDirective: BoxSmallFooterDirective;
public boxSmallContentDirective: BoxSmallContentDirective;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-box-small',
  template: `
    <div [ngClass]="styleClass" [mkColor]="backgroundColor" mkColorProperty="background-color">
      <div class="inner">
        <h3 *ngIf="header || boxSmallHeaderDirective" [ngClass]="headerStyleClass" [mkFontColor]="headerColor">
          {{header}}
          <ng-content select="mk-box-small-header"></ng-content>
        </h3>
        <p [ngClass]="contentStyleClass" [mkFontColor]="contentColor">
          <ng-container *ngIf="boxSmallHeaderDirective || boxSmallContentDirective || boxSmallFooterDirective else noDirective">
            <ng-content select="mk-box-small-content"></ng-content>
          </ng-container>
          <ng-template #noDirective>
            <ng-content></ng-content>
          </ng-template>
        </p>
      </div>
      <div *ngIf="iconStyleClass" class="icon">
        <i [ngClass]="iconStyleClass" [mkFontColor]="iconColor"></i>
      </div>
      <span *ngIf="footer || boxSmallFooterDirective" [ngClass]="footerStyleClass" [mkFontColor]="footerColor">
        {{footer}}
        <ng-content select="mk-box-small-footer"></ng-content>
      </span>
    </div>
  `,
  styles: [`
    .small-box.bg-color {
      color: #fff;
    }

    /deep/ .small-box-footer:hover {
      cursor: pointer;
    }

    /deep/ .small-box-footer a {
      color: rgba(255,255,255,0.8);
    }

    /deep/ .small-box-footer:hover a{
      color: rgb(255,255,255);
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'backgroundColor': [{ type: Input },],
'contentColor': [{ type: Input },],
'contentStyleClass': [{ type: Input },],
'footer': [{ type: Input },],
'footerColor': [{ type: Input },],
'footerStyleClass': [{ type: Input },],
'header': [{ type: Input },],
'headerColor': [{ type: Input },],
'headerStyleClass': [{ type: Input },],
'iconColor': [{ type: Input },],
'iconStyleClass': [{ type: Input },],
'styleClass': [{ type: Input },],
'boxSmallHeaderDirective': [{ type: ContentChild, args: [BoxSmallHeaderDirective, ] },],
'boxSmallFooterDirective': [{ type: ContentChild, args: [BoxSmallFooterDirective, ] },],
'boxSmallContentDirective': [{ type: ContentChild, args: [BoxSmallContentDirective, ] },],
};
}

function BoxSmallComponent_tsickle_Closure_declarations() {
/** @type {?} */
BoxSmallComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxSmallComponent.ctorParameters;
/** @type {?} */
BoxSmallComponent.propDecorators;
/** @type {?} */
BoxSmallComponent.prototype.backgroundColor;
/** @type {?} */
BoxSmallComponent.prototype.contentColor;
/** @type {?} */
BoxSmallComponent.prototype.contentStyleClass;
/** @type {?} */
BoxSmallComponent.prototype.footer;
/** @type {?} */
BoxSmallComponent.prototype.footerColor;
/** @type {?} */
BoxSmallComponent.prototype.footerStyleClass;
/** @type {?} */
BoxSmallComponent.prototype.header;
/** @type {?} */
BoxSmallComponent.prototype.headerColor;
/** @type {?} */
BoxSmallComponent.prototype.headerStyleClass;
/** @type {?} */
BoxSmallComponent.prototype.iconColor;
/** @type {?} */
BoxSmallComponent.prototype.iconStyleClass;
/** @type {?} */
BoxSmallComponent.prototype.styleClass;
/** @type {?} */
BoxSmallComponent.prototype.boxSmallHeaderDirective;
/** @type {?} */
BoxSmallComponent.prototype.boxSmallFooterDirective;
/** @type {?} */
BoxSmallComponent.prototype.boxSmallContentDirective;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
